import { Event } from "Global/Base/Events";

/**
 * Interface pro třídu pro sledování stavu a změn modifikátorů klávesnice.
 */
export interface IKeyboardModifiersWatcher extends IKeyboardModifiers {
    altChanged: Event<IKeyboardModifiersWatcher, boolean>;
    ctrlChanged: Event<IKeyboardModifiersWatcher, boolean>;
    shiftChanged: Event<IKeyboardModifiersWatcher, boolean>;
    modifiersChanged: Event<IKeyboardModifiersWatcher, IKeyboardModifiers>;
}

export class IKeyboardModifiersWatcher {
    private static _properties: (keyof IKeyboardModifiersWatcher)[] = ["modifiersChanged", "altChanged", "ctrlChanged", "shiftChanged"];
    private static _methods: (keyof IKeyboardModifiersWatcher)[] = [];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function") && instance instanceof IKeyboardModifiers;
    }
}

/**
 * Stavy modifikačních kláves
 */
export interface IKeyboardModifiers {
    alt: boolean;
    ctrl: boolean;
    shift: boolean;
}

export class IKeyboardModifiers {
    private static _properties: (keyof IKeyboardModifiers)[] = ["alt", "ctrl", "shift"];
    private static _methods: (keyof IKeyboardModifiers)[] = [];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
